
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/qualified",
      function () {
        return require("private-next-pages/destinations/qualified.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/qualified"])
      });
    }
  